import { Schema } from '@blade/std-lib'

export const ReferralCodeStatusSchema = Schema.Literals(['Hyped', 'Regular'])
export type ReferralCodeStatus = Schema.Schema.Type<
  typeof ReferralCodeStatusSchema
>

export * from './DelugeId'
export * as UserShort from './UserShort'
export * as UserMinimal from './user-minimal'
